// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-northeast-1",
    "aws_cognito_identity_pool_id": "ap-northeast-1:62545c85-113b-4839-9134-83cbe0f28434",
    "aws_cognito_region": "ap-northeast-1",
    "aws_user_pools_id": "ap-northeast-1_CnIFmGpDP",
    "aws_user_pools_web_client_id": "2ohnqi4vhv6n0hlml1f63sj3m0",
    "oauth": {},
    "aws_appsync_graphqlEndpoint": "https://hkrfoodljnftbboutw6wuhm7u4.appsync-api.ap-northeast-1.amazonaws.com/graphql",
    "aws_appsync_region": "ap-northeast-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://ud95mf84j9.execute-api.ap-northeast-1.amazonaws.com/prdnext",
            "region": "ap-northeast-1"
        }
    ]
};


export default awsmobile;
